enum Tabs {
    NOTIFICATIONS = "NOTIFICATIONS",
    USERS = "USERS",
}

enum ChannelSend {
    EMAIL = 1,
    APP = 2,
}

enum FrequencySend {
    DAILY = 1,
    EVERYTHREEDAYS = 2,
    WEEKLY = 3
}

enum DaysWeek {
    MONDAY = 1,
    TUESDAY = 2,
    WEDNESDAY = 3,
    THURSDAY = 4,
    FRIDAY = 5,
    SATURDAY = 6,
    SUNDAY = 7,
}

enum DaysWeekText {
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday',
    SUNDAY = 'sunday',
}


export { ChannelSend, DaysWeek, FrequencySend, Tabs, DaysWeekText };
